export default defineNuxtRouteMiddleware(async (to) => {
  // if we have ids in url to change to canonical strings, do so
  if (to.query.positions && hasPositionIds(to.query.positions)) {
    const canonicalQuery = await convertPositionIdsToNames(to.query);
    if (canonicalQuery && queryHasChanged(to.query, canonicalQuery)) {
      return navigateTo(
        {
          path: to.path,
          query: canonicalQuery,
        },
        {
          redirectCode: 301,
        },
      );
    }
  }

  const { $gtag } = useNuxtApp();
  const jobsSearchStore = useJobsSearchStore();
  await jobsSearchStore.lazyInit(to.query);
  $gtag?.logSearch();
});

function hasPositionIds(positions: string | string[] | undefined): boolean {
  if (!positions) return false;
  const positionArray = Array.isArray(positions) ? positions : [positions];
  return positionArray.some((pos) => !isNaN(Number(pos)) && Number.isInteger(Number(pos)));
}

async function convertPositionIdsToNames(
  query: Record<string, any>,
): Promise<Record<string, any> | null> {
  try {
    const result = await jobsService.resolveParams(query);

    if (result.isSuccess && result.data.static.positions.length > 0) {
      // create new query with position names instead of ids for better SEO
      const canonicalQuery = { ...query };
      canonicalQuery.positions = result.data.static.positions.map((pos) => pos.name);
      return canonicalQuery;
    }
  } catch (error) {
    console.warn('Failed to resolve position names for canonical URL:', error);
  }

  return null;
}

function queryHasChanged(original: Record<string, any>, canonical: Record<string, any>): boolean {
  // Compare positions specifically
  const originalPositions = Array.isArray(original.positions)
    ? original.positions
    : [original.positions];
  const canonicalPositions = Array.isArray(canonical.positions)
    ? canonical.positions
    : [canonical.positions];

  return JSON.stringify(originalPositions) !== JSON.stringify(canonicalPositions);
}
